import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import NarrowInfoContainer from "../components/NarrowInfoContainer";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { localizations } from '../localization/localization';


interface PasswordResetedProps {
    title: string,
    information: string,
    continueButtonLabel: string,
    onContinue: () => void;
}

const PasswordResetedSuccess: React.SFC<PasswordResetedProps> = (props) => {
    return <NarrowInfoContainer>
        <Grid item xs>
            <Grid container alignItems={'center'} justify={'center'} direction={"column"}  spacing={3}>
                <Grid item>
                    <Typography variant="h6">{localizations.validation.resetPassword}.</Typography>
                </Grid>
                <Grid item>
                    <Link to="/login" style={{ textDecoration: 'none' }}>
                        <Button variant="outlined">{localizations.actions.loggingInView}</Button>
                    </Link>
                </Grid>
            </Grid>
        </Grid>
    </NarrowInfoContainer>
}

export default PasswordResetedSuccess;


// WEBPACK FOOTER //
// ./src/login/PasswordResetedSuccess.tsx